import { supabase } from "@/lib/supabase/supabaseClient";
import { useDeleteProjectProps } from "./useDeleteProject.types";

export const deleteProject = async (project_id: useDeleteProjectProps) => {
    return await supabase.from('project').delete().eq('id', project_id);
}
